import { effects } from 'redux-saga'

import callWithHmac from '../effects/callWithHmac'
import {
  begin,
  end,
  receiveError,
} from '../../modules/loading'
import { receiveOffers, receiveProducts } from '../../modules/product'
import {
  receiveSignup,
} from '../../modules/signup/actions'

export default function* loadSignup({ invocation }, action) {
  try {
    yield effects.put.resolve(begin('signup', action.payload.id))

    const result = yield effects.call(
      callWithHmac,
      invocation.signupLoad,
      action.payload.id,
      action.payload.accessKey,
    )

    yield effects.put.resolve(receiveSignup(result.signup))
    if (result.offer) {
      yield effects.put.resolve(receiveOffers([result.offer]))
      yield effects.put.resolve(receiveProducts([], [result.offer.product]))
    }
    if (result.extraOffer) {
      yield effects.put.resolve(receiveOffers([result.extraOffer]))
      yield effects.put.resolve(receiveProducts([], [result.extraOffer.product]))
    }
  } catch (e) {
    if (!e.response || e.response.status >= 500) {
      throw e
    }

    yield effects.put.resolve(receiveError('signup', action.payload.id, e.response))
  } finally {
    yield effects.put.resolve(end('signup', action.payload.id))
  }
}



// WEBPACK FOOTER //
// ./deps/internal-components/src/redux/sagas/signup/loadSignup.js